import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Progress() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => { api.get("/progress/digest").then((r) => setD(r.data)); }, []);

  const send = async () => {
    setSending(true);
    try {
      const r = await api.post("/progress/digest/send");
      toast.success(`Sent to ${r.data.sent_to}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Send failed");
    } finally { setSending(false); }
  };

  if (!d) return <div className="text-neutral-400">Loading…</div>;

  return (
    <div>
      <div className="rs-underline mb-3" />
      <h1 className="font-display-heavy text-4xl">THIS WEEK</h1>
      <p className="text-neutral-400 mt-2">Everything you cleared and where to focus next.</p>

      <div className="grid md:grid-cols-3 gap-4 mt-8">
        <div className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
          <div className="uppercase text-xs text-neutral-400 font-display tracking-widest">Reps snapped</div>
          <div data-testid="digest-analyses-count" className="font-display-heavy text-5xl mt-2">{d.analyses_count}</div>
        </div>
        <div className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
          <div className="uppercase text-xs text-neutral-400 font-display tracking-widest">Drills done</div>
          <div data-testid="digest-drills-count" className="font-display-heavy text-5xl mt-2 text-red-500">{d.drills_completed}</div>
        </div>
        <div className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
          <div className="uppercase text-xs text-neutral-400 font-display tracking-widest">Focus cleared</div>
          <div data-testid="digest-cleared-count" className="font-display-heavy text-5xl mt-2 text-green-500">{d.focus_resolved}</div>
        </div>
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-4">
        <div className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
          <div className="font-display-heavy text-xl mb-3">TOP FOCUS AREAS</div>
          {d.top_focus.length === 0 ? <div className="text-neutral-400">Nothing active — you're clean.</div> : (
            <ul className="space-y-2">
              {d.top_focus.map((f) => (
                <li key={`focus-${f.sport}-${f.title}`} className="flex justify-between gap-3">
                  <span><span className="font-semibold">{f.title}</span> <span className="text-neutral-500">· {f.sport}</span></span>
                  <span className="text-red-500 font-display-heavy">{f.occurrences}×</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
          <div className="font-display-heavy text-xl mb-3">CLEARED THIS WEEK</div>
          {d.resolved_titles.length === 0 ? <div className="text-neutral-400">Nothing resolved yet this week.</div> : (
            <ul className="space-y-2">
              {d.resolved_titles.map((f) => (
                <li key={`resolved-${f.sport}-${f.title}`}><span className="text-green-500">✓</span> <span className="font-semibold">{f.title}</span> <span className="text-neutral-500">· {f.sport}</span></li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="mt-8 border border-neutral-800 rounded-md bg-neutral-900 p-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-display-heavy text-lg">Email me this recap</div>
          <div className="text-sm text-neutral-400">Sent to {user?.email}</div>
        </div>
        <Button data-testid="digest-send-btn" onClick={send} disabled={sending} className="h-12 px-6 bg-red-600 hover:bg-red-700 font-semibold">
          {sending ? "Sending…" : "Send now"}
        </Button>
      </div>
    </div>
  );
}
